import SplitPaneLayoutAPI from './split-pane-layout-api';

export default SplitPaneLayoutAPI;
